class Comment{
    constructor(json){
        this.id=json.id;
        this.comment_name=json.comment_name;
        this.comment_text=json.comment_text;
        this.comment_date=json.comment_date;
        this.comment_rate=json.comment_rate;
    }
}

export default Comment;